import React from "react";

const CalenderIntegration = (props) => {
  return (
    <>
      {props.data?.uncommonNewData?.calendar && (
        <div className="card">
          <h3>Google Calendar Integration</h3>
          <div className="card-body">
            <div class="datas w-100">
              <p>Gmail Address:</p>
              <del>{props.data?.uncommonOldData?.calendar}</del>
              <span>{props.data?.uncommonNewData?.calendar}</span>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CalenderIntegration;
